import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    additionalinfo:{},
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantSpokenLanguageGuid}/{SpokenLanguageName}/{SpokenLanguageDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantSpokenLanguageGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{SpokenLanguageName}/{SpokenLanguageDescription}/	
export const fetchSpokenLanguages = createAsyncThunk('spokenlanguage/get', async (incomingVariable, thunkAPI) => {
    console.log('called fetch spokenlanguage')
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.authToken + "/F9ED40BC-C3C9-4073-87E3-344DAB6C1F4A"+'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const spokenlanguageSlice = createSlice({
    name: 'spokenlanguages',
    initialState,
    reducers: {        
        spokenlanguageClear(state, action) {
            state.entities = initialState
            state.status = "idle" 
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchSpokenLanguages.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchSpokenLanguages.fulfilled, (state, action) => {
                state.status = 'success'
                const split = action.payload.Info[0].ViewInstanceData[0].SpokenLanguageVI.ProfileLangSpeakFrame
                const { LangSpeakDropdownList,...secondary} = split
                // console.log('spoke', LangSpeakDropdownList)
                state.entities = LangSpeakDropdownList
                state.additionalinfo = secondary
            })
            .addCase(fetchSpokenLanguages.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })
            
            
    }
})

export const { spokenlanguageClear} = spokenlanguageSlice.actions

export default spokenlanguageSlice.reducer

export const selectSpokenLanguageEntities = (state) => state.spokenlanguages.entities

export const selectSpokenLanguages = createSelector(selectSpokenLanguageEntities, (entities) =>
    Object.values(entities)
)

export const selectSpokenLanguageById = (state, SpokenLanguageId) => {
    return selectSpokenLanguageEntities(state)[SpokenLanguageId]
}

